// extracted by mini-css-extract-plugin
module.exports = {"iconBox":"_3yCW0"};